module.exports = __webpack_public_path__ + "static/media/maurides_Courses.fa78cc75.pdf";